import { ErrorMessages } from '@csp/csp-common-form';
import {
  FetchCallback,
  FetchState,
  identity,
  isLoading,
  Transformer,
  useFetch as useFetchHook,
  UseFetchReturnType,
  VarArgs,
} from '@csp/fe-hooks';
import { ErrorService } from '@csp/web-common';
import { useGetErrorMessage } from './useGetErrorMessage';

type UseFetch = {
  <T, P extends VarArgs>(fetchCallback: FetchCallback<T, P>, initialState?: FetchState<T>): UseFetchReturnType<T, P>;
  <T, S, P extends VarArgs>(
    fetchCallback: FetchCallback<S, P>,
    initialState: FetchState<T>,
    transformer: Transformer<S, T>,
    additionalErrorMessages?: ErrorMessages,
  ): UseFetchReturnType<T, P>;
};

export const useFetch: UseFetch = <T, S, P extends VarArgs>(
  fetchCallback: FetchCallback<S, P>,
  initialState: FetchState<T | S> = isLoading,
  transformer: Transformer<S, T | S> = identity,
  additionalErrorMessages?: ErrorMessages,
): UseFetchReturnType<T | S, P> => {
  const getErrorMessage = useGetErrorMessage(additionalErrorMessages);
  return useFetchHook(fetchCallback, initialState, transformer, getErrorMessage, ErrorService.handleError);
};
